import { FunctionComponent } from 'react';
import styled from 'styled-components';

interface PageDotProps {
  color?: string;
  size?: number;
  areaWidth?: number;
}

const PageDot: FunctionComponent<PageDotProps> = ({
  color = '#D8D8D8',
  size = 8,
  areaWidth,
}) => {
  return (
    <StyledSvg
      width={size}
      height={size}
      areaWidth={areaWidth}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4" r="4" fill={color} />
    </StyledSvg>
  );
};

export default PageDot;

const StyledSvg = styled.svg<{ areaWidth?: number }>`
  ${({ areaWidth }) => `width: ${areaWidth}px`}
`;
